import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect, useRef } from 'react';
import Icon from '../../Atoms/SocialIcons/Icon/Icon';
import HeaderIcons from './assets/HeaderIcons';
import { IconWrapper, EsuWrapper, CloseButton, HeaderESU } from './HeaderEsuWithIcon.style';
/* HeaderEsuWithIcon component */

var HeaderEsuWithIcon = function HeaderEsuWithIcon(_ref) {
  var title = _ref.title,
      topCopy = _ref.topCopy,
      successCopy = _ref.successCopy,
      privacyCopy = _ref.privacyCopy,
      buttonColor = _ref.buttonColor,
      subscribe = _ref.subscribe,
      validate = _ref.validate,
      isSuccess = _ref.isSuccess,
      errorMsg = _ref.errorMsg,
      isESUOpenInitial = _ref.isESUOpen; // Pre-interaction flag

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isClicked = _useState2[0],
      setisClicked = _useState2[1];

  var _useState3 = useState(isESUOpenInitial),
      _useState4 = _slicedToArray(_useState3, 2),
      isESUOpen = _useState4[0],
      setIsESUOpen = _useState4[1];

  var thisRef = useRef(null);
  useEffect(function () {
    if (isClicked) {
      if (isESUOpen && !isSuccess) {
        thisRef.current.querySelector('input').focus();
      } else {
        thisRef.current.querySelector('a').focus();
      }
    }
  }, [isClicked, isESUOpen, isSuccess]);
  /* Allow our ESU modal stuff to happen */

  var handleESUOpen = function handleESUOpen(e) {
    e.preventDefault(); // Update flag

    setisClicked(true); // Toggle our 'opened' state

    setIsESUOpen(!isESUOpen);
  };

  var handleEscClose = function handleEscClose(e) {
    // Close the modal if this is the ESC key
    if (e.keyCode === 27) {
      setIsESUOpen(false);
    }
  };
  /* Break out ESU render into own function */


  var renderESU = function renderESU() {
    return React.createElement(HeaderESU, {
      title: title,
      topCopy: topCopy,
      successCopy: successCopy,
      privacyCopy: privacyCopy,
      isSuccess: isSuccess,
      subscribe: subscribe,
      validate: validate,
      errorMsg: errorMsg,
      buttonColor: buttonColor,
      "aria-modal": "true"
    });
  };
  /* Break out Close button render into own function */


  var renderCloseButton = function renderCloseButton() {
    return React.createElement(CloseButton, {
      onClick: function onClick(e) {
        return handleESUOpen(e);
      },
      icon: HeaderIcons.close.icon,
      title: HeaderIcons.close.title,
      brand: HeaderIcons.close.title,
      target: "self",
      role: "button",
      href: "#",
      tabIndex: "0"
    });
  };
  /* Main render */


  return React.createElement(IconWrapper, {
    onKeyDown: function onKeyDown(e) {
      return handleEscClose(e);
    },
    ref: thisRef
  }, React.createElement(Icon, {
    onClick: function onClick(e) {
      return handleESUOpen(e);
    },
    icon: HeaderIcons.email.icon,
    title: HeaderIcons.email.title,
    brand: HeaderIcons.email.title,
    target: "self",
    role: "button",
    href: "#",
    tabIndex: "0"
  }), isESUOpen ? React.createElement(EsuWrapper, null, renderESU(), renderCloseButton()) : null);
};

HeaderEsuWithIcon.defaultProps = {
  isESUOpen: false,
  buttonColor: 'red'
};
export default HeaderEsuWithIcon;